<template>
    <div class="scancode">
        <h1>Scan Code</h1>
        <StreamBarcodeReader
            v-if="!lastBarcode"
            @decode="onDecode"
            @loaded="onLoaded"
        ></StreamBarcodeReader>
        <button v-if="lastBarcode" v-on:click="resetScan">Scan</button>
        <pre v-if="lastBarcode">{{lastBarcode}}</pre>
    </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
    name: "ScanCode",
    components: {
        StreamBarcodeReader,
    },
    data: function () {
    return {
        lastBarcode: null
    }},
    methods: {
        onDecode (result) {
            this.lastBarcode = result;
            this.$store.commit('addBarcode', result);
            console.log("onDecode",result)
        },
        onLoaded (result) {
            console.log("onLoaded",result)
        },
        resetScan () {
            this.lastBarcode = null;
        }
    }
}
</script>